<template>
  <div id="app" ref="main" :class="{ 'app-white': whiteBgRouter.includes($route.path) }">
    <template v-if="!wholePagePath.includes($route.path)">
      <!-- 头部  客户端模式隐藏 -->
      <home-header style="margin-bottom: 20px"></home-header>
      <div class="render-payload">
        <!-- 面包屑 客户端模式隐藏 -->
        <g-bread-crumb v-if="!noBreadMap.includes($route.path)"></g-bread-crumb>
        <!-- <home-more
          v-if="partnerType"
        ></home-more> -->
        <router-view></router-view>
      </div>
    </template>
    <template v-else>
      <div class="render-payload1" :style="{ marginBottom: $route.path == '/login' ? '0' : '' }">
        <router-view></router-view>
      </div>
    </template>
    <home-bottom v-if="!noFooterMap.includes($route.path)"></home-bottom>

    <div
      v-if="$route.path != '/login' && $route.path != '/passwordForget' && $route.path != '/register' && $route.path != '/nineGridShare'"
      class="fixedRightTools"
    >
      <div
        class="toolItem backTop"
        @click="backTop()"
      >
        回到<br />顶部
      </div>
      <el-popover
        placement="left-end"
        width="200"
        trigger="hover"
        popper-class="popWrapper"
        :offset="50"
      >
        <div
          slot="reference"
          class="toolItem xcx"
        >
          标源<br />小程序
        </div>
        <div class="popContent">
          <img
            src="@/assets/images/home/ewm.png"
            alt=""
          />
          <p class="line">
            微信扫一扫
          </p>
          <p>随时随地查询闲置商标</p>
        </div>
      </el-popover>
    </div>
  </div>
</template>
<script>
import { mapState } from "vuex";
import HomeHeader from "./views/home/components/home-header";
import GBreadCrumb from "@/components/breadcrumb";
import HomeBottom from "./views/home/components/home-bottom";
// import HomeMore from '@/views/home/components/home-more'

export default {
  components: {
    HomeHeader,
    // HomeMore,
    HomeBottom,
    GBreadCrumb
  },
  data() {
    return {
      whiteBgRouter: [], // 背景为白色的
      wholePagePath: ["/login", "/homePage", '/news'],
      noBreadMap: ["/homePage", "/agreementDetail",'/news'],
      noFooterMap: ["/login", "/agreementDetail"]
    };
  },
  computed: {
    ...mapState("userInfo", {
      partnerType: state => state.partnerType,
    })
  },
  watch: {
    $route() {
      let main = this.$refs.main;
      main.scrollTo(0, 0);
    }
  },
  methods: {
    backTop(){
      var target = 0,leader = 0,timer = null;
      clearInterval(timer);
      timer = setInterval(function(){
        // target 目标值 leader初始时是滚动的高度
        var step = (target - leader)/10;
        // 如果大于0向上取整小于0向下取整
        step = step > 0 ? Math.ceil(step) : Math.floor(step);
        // leader发生改变
        leader = leader + step;
        // 返回到哪一个地方
        window.scrollTo(0,leader);
        if (leader == target) {
        clearInterval(timer);
        }
      },30)
    },
  }
};
</script>
<style lang="scss" scoped>
#app {
  min-height: 100vh;
  // font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  background-color: #f5f5f5;
  // padding-bottom: 130px;
  //min-height: 1300px;
}
.render-payload {
  margin: 0 auto 0;
  width: 1280px;
  padding-bottom: 20px;
  position: relative;
  box-sizing: border-box;
  // min-height: calc(100vh - 60px);
}
.render-payload1 {
  width: 100%;
  margin-bottom: 0px;
}
#app.app-white {
  background-color: #fff;
}

::v-deep .el-backtop{
    width: 50px;
    height: 50px;
    line-height: 50px;
    border-radius: 2px;
    .bckTop{
      width: 50px;
      height: 50px;
      line-height: 50px;
      border-radius: 2px;
      background-color: #fff;
      box-shadow: 0 0 6px rgba(0,0,0, .12);
      text-align: center;
      color: #ff7200;
      img{
        width: 24px;
        height: 24px;
        position: relative;
        top: 5px;
      }
    }
  }
  .fixedRightTools{
    position: fixed;
    right: 10px;
    bottom: 200px;
    width: 42px;
    background: #FFFFFF;
    box-shadow: 0px 0px 6px 0px rgba(11,17,60,0.1);
    border-radius: 2px;
    display: flex;
    flex-direction: column;
    font-size: 12px;
    padding: 0 3px;
    box-sizing: border-box;
    .toolItem{
      color: #666666;
      border-bottom: 1px solid #E4E4E4;
      line-height: 16px;
      cursor: pointer;
      &:last-child{
        border-bottom: none;
      }
      &:hover{
        color: #ff7200;
      }
    }
    .backTop{
      padding: 30px 0 15px;
      background: url('@/assets/images/home/icon-back-top.png') no-repeat ;
      background-size: 26px;
      background-position-x: center;
      background-position-y: 10px;
      &:hover{
        background: url('@/assets/images/home/icon-back-top-active.png') no-repeat ;
        background-size: 26px;
        background-position-x: center;
        background-position-y: 10px;
      }
    }
    .xcx{
      padding: 40px 0 15px;
      background: url('@/assets/images/home/icon-xcx.png') no-repeat ;
      background-size: 26px;
      background-position-x: center;
      background-position-y: 10px;
      &:hover{
        background: url('@/assets/images/home/icon-xcx-active.png') no-repeat ;
        background-size: 26px;
        background-position-x: center;
        background-position-y: 10px;
      }
    }
  }
</style>
<style lang="scss" >
  .popWrapper{
    margin-right: 5px!important;
    margin-bottom: -50px!important;
  }
  .popContent{
    padding: 10px 15px;
    font-size: 12px;
    width: 200px;
    text-align: center;
    img{
      width: 100%;
    }
    .line{
      font-weight: bold;
      color: #222222;
      margin-bottom: 0px;
      font-size: 14px;
    }
    p{
      margin-bottom: 6px;
      line-height: 16px;
      margin-top: 10px;
    }
  }
</style>
